// ✅ Final JobPostedSuccess.js – With Confetti, Ticket ID, Accurate Location
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Confetti from "react-confetti";
import { useWindowSize } from "react-use";

const JobPostedSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { width, height } = useWindowSize();

  const jobId = location.state?.jobId || "N/A";
  const scheduledAt = location.state?.scheduledAt || "";
  const jobAddress = location.state?.location || "Not provided";

  const formattedDateTime = scheduledAt
    ? new Date(scheduledAt).toLocaleString(undefined, {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "ASAP";

  const copyToClipboard = () => {
    if (jobId && jobId !== "N/A") {
      navigator.clipboard.writeText(jobId);
      alert("📋 Ticket ID copied to clipboard!");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-100 to-blue-100 p-4 relative overflow-hidden">
      <Confetti width={width} height={height} numberOfPieces={250} />

      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-xl text-center z-10 w-full">
        <div className="text-5xl mb-4">🎉</div>
        <h1 className="text-3xl font-extrabold text-green-600 mb-2">Job Posted!</h1>
        <p className="text-gray-700 text-lg mb-4">
          Your job has been posted successfully.
        </p>

        <div className="text-sm text-gray-600 mb-2">
          <strong className="text-blue-800">📅 Scheduled For:</strong>{" "}
          {formattedDateTime}
        </div>

        <div className="text-sm text-gray-600 mb-4">
          <strong className="text-pink-700">📍 Location:</strong> {jobAddress}
        </div>

        <div className="mb-4">
          <strong className="text-yellow-600">🎫 Job Ticket ID:</strong>{" "}
          <span className="text-blue-600 font-semibold">{jobId}</span>
        </div>

        <button
          onClick={copyToClipboard}
          disabled={jobId === "N/A"}
          className={`w-full py-2 px-4 rounded-md text-white text-sm font-semibold transition ${
            jobId === "N/A"
              ? "bg-gray-300 cursor-not-allowed"
              : "bg-blue-500 hover:bg-blue-600"
          }`}
        >
          {jobId === "N/A" ? "Ticket Unavailable" : "Copy Ticket ID"}
        </button>

        <button
          onClick={() => navigate("/your-jobs")}
          className="mt-3 w-full py-2 px-4 rounded-md bg-indigo-500 hover:bg-indigo-600 text-white text-sm font-semibold transition"
        >
          View Your Jobs
        </button>

        <p className="mt-4 text-xs text-gray-500">
          Want to make changes? Go to your jobs and tap the edit icon ✏️
        </p>
      </div>
    </div>
  );
};

export default JobPostedSuccess;
